import { Classification } from "@/types/classification";
import { Question } from "./questions";
import { SchoolWithoutTeachers } from "@/types/users/schoolWithoutTeachers";

export const ActivityTemplateStatuses = ["פורסם למשתמשים", "פנימי"] as const;

export type ActivityTemplateStatus = (typeof ActivityTemplateStatuses)[number];

export type ActivityTemplate = {
    id: number;
    name: string;
    description?: string;
    preparation?: string;
    icon?: File | string | null;
    image?: File | string | null;
    video?: File | string | null;
    pdf?: File | string | null;
    preview_video?: File | string | null;
    preview_pdf?: File | string | null;
    learning_pdf?: File | string | null;
    skills: Classification[];
    location: Classification;
    independency_level: Classification;
    subject: Classification;
    tools: Classification[];
    classes: string[];
    invited_schools: SchoolWithoutTeachers[];
    stages_names: string[];
    stages_duration: number[];
    stages_from_pdf_page: number[];
    stages_to_pdf_page: number[];
    stages_from_video_minute: number[];
    stages_from_video_second: number[];
    stages_to_video_minute: number[];
    stages_to_video_second: number[];
    stages_videos?: ({
        id?: number;
        video?: string | null;
        file?: File;
    } | null)[];
    bonus_stage_description?: string;
    bonus_stage_image?: File | string | null;
    internal_rank: number;
    external_rank: number;
    complexity_level: number;
    activity_completion_precentage: number;
    reflection_questions: Question[];
    feedback_questions: Question[];
    status: ActivityTemplateStatus;
};

export const getActivityTemplateQueryKey = (id?: number) =>
    id ? ["activityTemplates", id] : ["activityTemplates"];
